import React from 'react';
import css from './sideProjects.module.scss';
import OfferTn from "../sideProjects/OfferTn/OfferTn";
import GoToSource from "../sideProjects/GoToSource/GoToSource";
import SaveData from "../sideProjects/SaveData/SaveData";
import ZLand from '../sideProjects/zLand/zLand';
import Mario from "./mario/mario";
import FG from "./fetch_get/FG";
import UpdateBackupDisk from "./update_backup_disk/UpdateBackupDisk";


function SideProjects() {
    return (
        <div className={css.container} id='sideProjects'>
            <h1>Side Projects</h1>
            <div/>
            <div className={css.projects}>
                <ZLand/>
                <OfferTn/>
                <GoToSource/>
                <SaveData/>
                <UpdateBackupDisk/>
                <FG/>
                <Mario/>
            </div>
        </div>
    );
}

export default SideProjects;
